import { schema } from 'normalizrplus';

const workspace = new schema.Entity('workspaces', {}, { keyNamingStrategy: 'camelCase' });
const user = new schema.Entity('users', {}, { keyNamingStrategy: 'camelCase' });
const team = new schema.Entity('teams', {}, { keyNamingStrategy: 'camelCase' });
const invitation = new schema.Entity('invitations', {}, { keyNamingStrategy: 'camelCase' });

const userSchema = {
  workspace,
  teams: [team],
};

const workspaceSchema = {
  owner: user,
  users: [user],
};

user.define(userSchema);
workspace.define(workspaceSchema);

export {
  user,
  workspace,
  invitation,
};
